export default __webpack_public_path__ + "static/media/2289.06490ef6.png";